import { StyledTag } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Stack } from '@mui/material';
import { memo } from 'react';
import type { PaymentMethodBadgesProps as Props } from './types';

export const PaymentMethodBadges = memo(
  ({ className, inUse, isDefault }: Props) => {
    if (!inUse && !isDefault) return null;

    return (
      <Stack
        direction="row"
        gap={1}
        className={classnames('PaymentMethodBadges', className)}
      >
        {isDefault && (
          <StyledTag
            variant="outlined"
            color="success"
            size="small"
            label="Default"
          />
        )}
        {inUse && (
          <StyledTag
            variant="outlined"
            color="primary"
            size="small"
            label="Active"
          />
        )}
      </Stack>
    );
  }
);

PaymentMethodBadges.displayName = 'PaymentMethodBadges';
